import React from "react";

const ValidationError = ({error}) => {
  return <span className="invalid-feedback">{error}</span>
}

export default ValidationError;